import React from 'react';

const CIRCLE_FILL = '#E1F4D3';   
const STROKE_COLOR = '#1B452A'; 

export const DownloadIcon = ({ width = 24, height = 24, className }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 53 53"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M26.342 50.1995C29.475 50.1995 32.5773 49.5825 35.4718 48.3835C38.3663 47.1846 40.9963 45.4273 43.2116 43.2119C45.427 40.9966 47.1843 38.3666 48.3832 35.4721C49.5821 32.5776 50.1992 29.4753 50.1992 26.3424C50.1992 23.2094 49.5821 20.1071 48.3832 17.2126C47.1843 14.3181 45.427 11.6881 43.2116 9.47278C40.9963 7.25743 38.3663 5.50012 35.4718 4.30119C32.5773 3.10225 29.475 2.48517 26.342 2.48517C20.0147 2.48517 13.9466 4.99869 9.47247 9.47278C4.99838 13.9469 2.48486 20.015 2.48486 26.3424C2.48486 32.6697 4.99838 38.7378 9.47247 43.2119C13.9466 47.686 20.0147 50.1995 26.342 50.1995Z"
        fill={CIRCLE_FILL}
      />
      <path
        d="M26.3426 17.6444V32.5551M18.8872 27.5849L26.3426 35.0403L33.7979 27.5849"
        stroke={STROKE_COLOR}
        strokeWidth="2.98215"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.46146 11.4316C3.35505 15.5817 1.49121 20.7508 1.49121 26.3423C1.49121 40.0602 12.6246 51.1936 26.3424 51.1936C40.0603 51.1936 51.1937 40.0602 51.1937 26.3423C51.1937 12.6244 40.0603 1.49109 26.3424 1.49109C22.7887 1.49109 19.3841 2.23663 16.3274 3.60344"
        stroke={STROKE_COLOR}
        strokeWidth="2.98215"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};